var exploreLinks = document.getElementsByClassName('explore_navigation__link');
var exploreDivs = document.getElementsByClassName('location-card');

for (var i = 0; i < exploreLinks.length; i++) {
    exploreLinks[i].addEventListener("click", function(){
        for (var i = 0; i < exploreLinks.length; i++) {
            exploreLinks[i].classList.remove('active');
        }
        this.classList.add('active');

        listings(this);
    });
}

function listings(link) {
    var data = link.getAttribute('data-id');

    for (var i = 0; i < exploreDivs.length; i++) {
        if (exploreDivs[i].classList.contains(data)) {
            exploreDivs[i].classList.add('active');
        } else {
            exploreDivs[i].classList.remove('active');
        }
    }
}